import { FormattedMessage } from "react-intl";
import { Loader2 } from "lucide-react";

const SettingsSaveStatus = ({ status, error, retry }) => (
    <div role="status" aria-live="polite" className="text-[13px]">
        {status === "saving" && <span className="inline-flex items-center gap-1.5 text-gray-400"><Loader2 size={13} className="animate-spin" /><FormattedMessage id="teamroom.builder.status.saving" /></span>}
        {status === "saved" && <span className="inline-flex items-center gap-1.5 font-bold text-standart-ocean"><span className="w-2 h-2 rounded-full bg-bright-green" /><FormattedMessage id="teamroom.builder.status.saved" /></span>}
        {error && <div className="text-red-500 mt-2">{error} <button type="button" onClick={retry} disabled={status === "saving"} className="font-bold underline disabled:opacity-50"><FormattedMessage id="teamroom.settings.retry" /></button></div>}
    </div>
);

export default SettingsSaveStatus;
